import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { EquipmentTypeDataDDL } from '../../../../../../Components/CommonDDL/STPEquipmentTypeDDL';
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { STPEquipmentMasterPostDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPMaster/STPEquipmentMasterSlice';
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';


export default function STPEquipmentMasterPopup(props) {

    const { handleOnCloseClick, open, EditIcon, Flag, handleIsPost, apiFlag, rowData, HWard, WLable } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [WardName, setWardName] = useState({
        ID: Flag === 'Update' ? rowData.m_WardID : 0,
        Label: Flag === 'Update' ? rowData.wardName : "Select...",
    })


    const [EquipmentType, setEquipmentType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_stP_EquipmentTypeID : 0,
        Label: Flag === 'Update' ? rowData.equipmentType : "Select...",
    })
    

    const [EquipmentName, setEquipmentName] = useState(Flag === 'Update' ? rowData.equipmentDetails : '')


    const handlePost = () => {
        const data = {
            M_STP_EquipmentMasterID: Flag === 'Update' ? rowData.m_stP_EquipmentMasterID : '0',
            M_WardID: WardName.ID,
            M_STP_EquipmentTypeID: EquipmentType.ID,
            EquipmentDetails: EquipmentName,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(STPEquipmentMasterPostDataAPI({ data }))

    }
    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Equipment Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    <WardNameDataDDL
                                        WardName={WardName}
                                        setWardName={setWardName}
                                        rowData={rowData}
                                        Flag={Flag}
                                        HWard={HWard}
                                        WLable={WLable}
                                    // Flag='ward'
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <EquipmentTypeDataDDL
                                        EquipmentType={EquipmentType}
                                        setEquipmentType={setEquipmentType}
                                        UnitType='0'
                                        rowData={rowData}
                                        Flag={Flag}
                                    // Flag='ward'
                                    />
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Equipment Name </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="EquipmentName"
                                            value={EquipmentName}
                                            onChange={(e) => setEquipmentName(e.target.value)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-lg-4 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                    disabled={
                                        WardName.ID == '' || EquipmentType.ID == 0 || EquipmentName == ''
                                    }

                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}